import {useNavigate} from "react-router-dom";
import {DASHBOARD} from "../../constants/routs.constants";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="not-found">
                <h3 className="not-found__title">404</h3>
                <p className="not-found__text">Wrong route</p>
            </div>
            <div className="not-found__box-button">
                <button onClick={() => {
                    navigate(DASHBOARD)
                }} className="not-found__button">Return to Home
                </button>
            </div>
        </>
    )
}

export default NotFound
